module.exports = __webpack_public_path__ + "src/assets/games/43/16.jpg";